import CustomInputForm from './CustomInputForm';

export default CustomInputForm;